import * as actionTypes from '../actions/actionTypes'
import {updateObject} from '../../helpers/utilities'

const initialState = {
  merchant_scrubber_imports: [],
  loading: false,
  error: null,
  merchant_scrubber_dialog_open: false,
}

const fetchMerchantScrubberImportsStart = (state, action) => {
  return updateObject(state, {loading: true, merchant_scrubber_imports: []})
}

const fetchMerchantScrubberImportsSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    merchant_scrubber_imports: action.merchant_scrubber_imports
  })
}

const fetchMerchantScrubberImportsFail = (state, action) => {
  return updateObject(state, {loading: false})
}

const addMerchantScrubberStart = (state, action) => {
    return updateObject(state, {saving: true})
}

const addMerchantScrubberSuccess = ( state, action ) => {
    return updateObject( state, {
        loading: false,
        saving: false,
        id: action.id,
        merchant_scrubber_dialog_open: false
    } );
};

const addMerchantScrubberFail = (state, action) => {
    return updateObject(state, {saving: false})
}

const openMerchantScrubberDialog = (state, action) => {
    return updateObject(state, {
        merchant_scrubber_dialog_open: true
    })
}

const closeMerchantScrubberDialog = (state, action) => {
    return updateObject(state, {
        merchant_scrubber_dialog_open: false
    })
}

const reducer = (state = initialState, action) => {
  switch(action.type){
    case actionTypes.FETCH_MERCHANT_SCRUBBER_IMPORTS_START:
      return fetchMerchantScrubberImportsStart(state, action)
    case actionTypes.FETCH_MERCHANT_SCRUBBER_IMPORTS_SUCCESS:
      return fetchMerchantScrubberImportsSuccess(state, action)
    case actionTypes.FETCH_MERCHANT_SCRUBBER_IMPORTS_FAIL:
      return fetchMerchantScrubberImportsFail(state, action)
    case actionTypes.ADD_MERCHANT_SCRUBBER_START:
        return addMerchantScrubberStart(state, action)
    case actionTypes.ADD_MERCHANT_SCRUBBER_SUCCESS:
        return addMerchantScrubberSuccess(state, action)
    case actionTypes.ADD_MERCHANT_SCRUBBER_FAIL:
        return addMerchantScrubberFail(state, action)
    case actionTypes.OPEN_MERCHANT_SCRUBBER_DIALOG:
        return openMerchantScrubberDialog(state, action)
    case actionTypes.CLOSE_MERCHANT_SCRUBBER_DIALOG:
        return closeMerchantScrubberDialog(state, action)
    default:
      return state
  }
}
    
export default reducer
